import { useEffect, useState } from 'react'

import Message from './Message'
import _ from 'lodash'
import axios from '../../axios/axios'
import { isAfter } from 'date-fns'

export const shouldShow = (message, showAll) => {
  if (showAll) {
    return true
  }
  const { visible, expires, heading, content } = message?.attributes ?? message ?? {}
  if (!visible || (!heading && !content)) {
    return false
  }

  if (expires && isAfter(new Date(), new Date(expires))) {
    return false
  }

  return true
}

const Messages = ({ forceUpdate, showAll }) => {
  const [messages, setMessages] = useState()

  useEffect(() => {
    ;(async () => {
      const messages = await axios.get('/admin/message')
      // setMessages(_.filter(messages.data.data, (m) => shouldShow(m, showAll)))
      setMessages(messages.data.data)
    })()
  }, [forceUpdate, showAll])

  return (
    <>
      {messages?.map((message, i) =>
        showAll || shouldShow(message) ? (
          <Message
            key={i}
            message={{
              ...message,
            }}
          />
        ) : null,
      )}
    </>
  )
}

export default Messages
